

import { AiFillFacebook } from "react-icons/ai";
import { RiTwitterXFill } from "react-icons/ri";
import { LuInstagram } from "react-icons/lu";
import { IoLogoYoutube } from "react-icons/io5";
import { FaRss } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa6";
import Link from "next/link";
import { useLocale } from "next-intl";


export default function SocialMedia() {

  const locale = useLocale()


  return (
    <div className="flex w-full gap-3 text-gray-700" aria-label="Social media links">
      <a
        href="https://www.facebook.com/PadlevOfficial"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Visit Padlev on Facebook"
        className="hover:text-bl cursor-pointer"
      >
        <AiFillFacebook size={32} aria-hidden="true" focusable="false" />
      </a>

      <Link href="https://x.com/PadlevOfficial" target="_blank" title="X Account" aria-label="Visit Padlev on X">
        <RiTwitterXFill size={32} className="hover:text-black cursor-pointer" aria-hidden="true" focusable="false" />
      </Link>

      <a
        href="https://www.instagram.com/padlevofficial"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Visit Padlev on Instagram"
        className="hover:text-orange-700 cursor-pointer"
      >
        <LuInstagram size={32} aria-hidden="true" focusable="false" />
      </a>

      <a
        href="https://www.youtube.com/@padlevofficial"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Visit Padlev on YouTube"
        className="hover:text-red-700 cursor-pointer"
      >
        <IoLogoYoutube size={32} aria-hidden="true" focusable="false" />
      </a>

      <a
        href="https://www.tiktok.com/@padlevofficial"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Visit Padlev on TikTok"
        className="hover:text-black cursor-pointer"
      >
        <FaTiktok size={32} aria-hidden="true" focusable="false" />
      </a>

      <Link href={`/${locale}/rss`} target="_blank" rel="noopener noreferrer" title="RSS Feed" aria-label="Open Padlev RSS feed">
        <FaRss size={32} className="hover:text-primary cursor-pointer" aria-hidden="true" focusable="false" />
      </Link>
    </div>
  );
}